export default __webpack_public_path__ + "static/media/React 2.a544fd8c.png";